import { completedSeqFlowPostfix } from '../../../../features/tracking/models/CompletedItemsStore';
import { Guid } from '../../../model/guid';
import { ItemsReducerState } from '../../../reducers/items/itemsReducer';
import { createGetMaybeItemByIdFromItemsReducerState } from './getItemByIdFromItemsReducerState';
import { isSequencedFlowItem, isSequencedFlowStep } from '@ael/core-api';
import { List, Set } from 'immutable';

/* LEGACY: Convert completed presenter to completed SQ item - very ugly, but runs only once per user, if old version of tracking data is used.

In the past, Presenter (obsolsete now) was saved on the server (basic mode) and offline as
Slide1, Slide2, Slide3 - similar as non SQ item. There was no "Presenter-Completed" or  "Presenter" (started) in the tracking data.
After presenter got merged to Sequenced Content, we needed a way to fix the old obsolete data, and to mark the the item as completed, if all its steps were coompleted.
This ugly function is the result.
Hopefully we can delete it after something like 2 years.
PS: It runs only once per progress tracking, if old (v1) version of tracking is detected.
*/
export const getLegacyPresenterDataCreator =
  (getItems: () => ItemsReducerState) =>
  (itemId: Guid, finishedItemIds?: Set<string>): List<Guid> | null => {
    if (!finishedItemIds) {
      return null;
    }

    const items = getItems();

    const getItemByIdAllowUndefined = createGetMaybeItemByIdFromItemsReducerState(items);
    const item = getItemByIdAllowUndefined(itemId);
    if (!item) {
      return null;
    }

    if (!isSequencedFlowStep(item)) {
      return null;
    }

    const parentId = item.parentId.parentId;
    if (!parentId) {
      return null;
    }
    if (finishedItemIds.contains(parentId)) {
      return null;
    }

    const parent = getItemByIdAllowUndefined(parentId);
    if (!parent || !isSequencedFlowItem(parent)) {
      return null;
    }
    const completedChildItems = parent.contentItems.filter((childId: string) => finishedItemIds.contains(childId));

    if (parent.contentItems.count() === completedChildItems.count()) {
      // Return "start" of SQ item and "completed" together with children
      return parent.contentItems
        .concat(parentId)
        .concat(parentId + completedSeqFlowPostfix)
        .toList();
    }
    // Return "start" of SQ item together with children
    return completedChildItems.concat(parentId).toList();
  };
